var irreducible = require('./irreducible');
var isString = require('./isString');

module.exports = irreducible('String', isString);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/String.js
 ** module id = 495
 ** module chunks = 0
 **/